// react
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'router';

// components
import { ChromeTemplate } from '@karehero/llama/pwa/templates/ChromeTemplate/ChromeTemplate';
import { type LinkItem } from '@karehero/llama/pwa/molecules/NavDrawer/NavDrawer';

/**
 * RootPartnerAdmin is the root layout for referring partner admin pages.
 * Uses ChromeTemplate for consistent navigation behaviour with other roots.
 */
export const RootPartnerAdmin = () => {
  // hooks
  const navigate = useNavigate();

  const links: LinkItem[] = useMemo(
    () => [
      {
        icon: 'gear',
        label: 'Code Management',
        onClick: () => navigate(ROUTES.PARTNER_ADMIN),
      },
    ],
    [navigate],
  );

  return <ChromeTemplate links={links} activePath={ROUTES.PARTNER_ADMIN} />;
};

RootPartnerAdmin.displayName = 'RootPartnerAdmin';
export default RootPartnerAdmin;
